import { FC, ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    updateFilter,
    durationSelector,
    transportTypeSelector
} from '../../../reducers/filters';
import { MultiColumnDropdownWithLabelTravelTime } from '../../../search/common/Dropdown.styles';

import { DropdownContainer } from '../../../search/common/DropdownContainer';
import { DropdownWithLabel } from '@blueprint/dropdown';

const durationOptionsText: { [key: string]: string } = {
    '900': '15 minutes',
    '1800': '30 minutes',
    '2700': '45 minutes',
    '3600': '1 hour',
    '4500': '1 ¼ hour'
};
const transportTypeOptionsText: { [key: string]: string } = {
    driving: 'Driving',
    walking: 'Walking',
    walking_train: 'Train',
    public_transport: 'Public transport',
    cycling: 'Cycling'
};

export const SelectMaxTravelTimeAndTransportMode: FC = () => {
    const reduxDispatch = useDispatch();
    const { selectedValue: durationValue, options: durationOptions } =
        useSelector(durationSelector);

    const {
        selectedValue: transportTypeSelectedValue,
        options: transportTypeOptions
    } = useSelector(transportTypeSelector);

    const onDurationChange = (evt: ChangeEvent<HTMLSelectElement>) => {
        reduxDispatch(updateFilter('duration', evt.currentTarget.value));
    };

    const onTransportTypeChange = (evt: ChangeEvent<HTMLSelectElement>) => {
        reduxDispatch(updateFilter('transportType', evt.currentTarget.value));
    };

    const durationTitleDisplay =
        durationOptionsText[durationValue || durationOptions[0].value];

    const travelTypeDurationType =
        transportTypeOptionsText[
            transportTypeSelectedValue || transportTypeOptions[0].value
        ];
    const title = `${durationTitleDisplay} • ${travelTypeDurationType}`;

    const travelTimeLabelText = 'Max travel time';

    return (
        <MultiColumnDropdownWithLabelTravelTime
            title={title}
            label="Travel time"
            testId="sub_header_max-travel-and-transport-type-dropdowns"
            isLeft
        >
            <DropdownContainer>
                <DropdownWithLabel
                    id="duration"
                    onChange={onDurationChange}
                    value={durationValue}
                    hasBorderRadius
                    name="duration"
                    label={travelTimeLabelText}
                    aria-label="Max travel time"
                    data-testid="sub_header_select-max-travel-time-dropdown"
                >
                    {durationOptions?.map((option) => {
                        const { label, value } = option;

                        return (
                            <option
                                key={`sub-header-duration-${value}`}
                                value={value}
                            >
                                {label}
                            </option>
                        );
                    })}
                </DropdownWithLabel>
            </DropdownContainer>
            <DropdownContainer>
                <DropdownWithLabel
                    id="transportType"
                    onChange={onTransportTypeChange}
                    value={transportTypeSelectedValue}
                    name="transportType"
                    hasBorderRadius
                    label={travelTimeLabelText}
                    aria-label="Transport mode"
                    data-testid="sub_header_select-transport-type-dropdown"
                >
                    {transportTypeOptions?.map((option) => {
                        const { label, value } = option;

                        return (
                            <option
                                key={`sub-header-transportType-${value}`}
                                value={value}
                            >
                                {label}
                            </option>
                        );
                    })}
                </DropdownWithLabel>
            </DropdownContainer>
        </MultiColumnDropdownWithLabelTravelTime>
    );
};
